import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

export default function About() {
  const { t } = useLanguage();

  return (
    <div className="container mx-auto px-4 py-16 max-w-4xl">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-16">
        <h1 className="text-5xl font-bold text-brand-navy mb-4">{t('about.title')}</h1>
        <div className="h-1 w-24 bg-brand-red mx-auto rounded mb-6"></div>
      </motion.div>
      <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="prose prose-lg mx-auto text-gray-700">
        <p className="lead text-2xl text-brand-navy font-medium mb-8 text-center">
          {t('about.welcome')}
        </p>
        <div className="bg-gray-50 p-8 rounded-2xl border border-gray-100 mb-8 float-right md:w-1/2 md:ml-8 md:mb-4">
          <h3 className="text-xl font-bold text-brand-navy mb-2 mt-0">{t('about.missionTitle')}</h3>
          <p className="text-base m-0">
            {t('about.missionText')}
          </p>
        </div>
        <p className="mb-6">{t('about.p1')}</p>
        <p className="mb-6">{t('about.p2')}</p>
        <p className="mb-6">{t('about.p3')}</p>
        <div className="mt-12 text-center p-8 bg-brand-navy text-white rounded-2xl">
          <h3 className="text-2xl font-bold mb-4 text-brand-gold">{t('about.footerBox')}</h3>
          <p className="mb-0">{t('about.footerText')}</p>
        </div>
      </motion.div>
    </div>
  );
}